import { render, staticRenderFns } from "./MpPay.vue?vue&type=template&id=0bcbc70d&scoped=true"
import script from "./MpPay.vue?vue&type=script&lang=js"
export * from "./MpPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcbc70d",
  null
  
)

export default component.exports